<template>
  <div
    class="labeled-field flex flex-grow flex-col"
    :class="{ pristine: props.field?.pristine }"
  >
    <label
      class="text-sm text-titan-purple"
      :class="props.labelClass"
      data-test="label"
      >{{ props.label }}</label
    >
    <slot></slot>
    <ValidationMessage :field="props.field" />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps(['label', 'field', 'labelClass']);
</script>
